import { render, staticRenderFns } from "./extensionCards.vue?vue&type=template&id=267cf3ce&scoped=true&"
import script from "./extensionCards.vue?vue&type=script&lang=js&"
export * from "./extensionCards.vue?vue&type=script&lang=js&"
import style0 from "./extensionCards.vue?vue&type=style&index=0&id=267cf3ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267cf3ce",
  null
  
)

export default component.exports